export const Data=[
    {
       "day":"Mon",
       "status1":"Open",
       "status2":"Close",
        "time":"10:00",
        "mode1":"AM",
        "mode2":"PM",
        "time2":"06:00",
     },
     {
        "day":"Tue",
        "status1":"Open",
        "status2":"Close",
         "time":"10:00",
         "mode1":"AM",
         "mode2":"PM",
         "time2":"06:00",
      },
      {
        "day":"wed",
        "status1":"Open",
        "status2":"Close",
         "time":"10:00",
         "mode1":"AM",
         "mode2":"PM",
         "time2":"06:00",
      },
      {
        "day":"Thu",
        "status1":"Open",
        "status2":"Close",
         "time":"10:00",
         "mode1":"AM",
         "mode2":"PM",
         "time2":"06:00",
      },
      {
        "day":"Fri",
        "status1":"Open",
        "status2":"Close",
         "time":"10:00",
         "mode1":"AM",
         "mode2":"PM",
         "time2":"06:00",
      },
      {
        "day":"Sat",
        "status1":"Open",
        "status2":"Close",
         "time":"10:00",
         "mode1":"AM",
         "mode2":"PM",
         "time2":"06:00",
      },
      {
        "day":"Sun",
        "status1":"Open",
        "status2":"Close",
         "time":"10:00",
         "mode1":"AM",
         "mode2":"PM",
         "time2":"06:00",
      },
]